import { render, staticRenderFns } from "./TheTeamReport.vue?vue&type=template&id=0fe50b24&"
import script from "./TheTeamReport.vue?vue&type=script&lang=js&"
export * from "./TheTeamReport.vue?vue&type=script&lang=js&"
import style0 from "./TheTeamReport.vue?vue&type=style&index=0&id=0fe50b24&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports